import axiosClient from '../util/request';
import { RcFile } from 'antd/es/upload';

const uploadRepo = {
  documents: () => axiosClient.get('/v1/employees/documents'),

  upload: (file: RcFile, type : string | undefined ) => {
    const formData = new FormData();
    formData.append('file', file);

    return axiosClient.post(`/v1/employees/documents/${type}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  removeUplodadedFile: (type: string) => axiosClient.delete(`/v1/employees/documents/${type}`),
};

export default uploadRepo;